<template>
	<span class="close-btn"><i class="el-icon-close" @click="close"></i></span>
</template>
<script>
export default {
	methods:{
		close(){
			this.$emit('close');
		}
	}
};
</script>
<style lang="scss" scoped>
.close-btn {
	position: absolute;
	right: -40px;

	i {
		cursor: pointer;
		width: 30px;
		height: 30px;
		display: inline-block;
		background-color: white;
		text-align: center;
		border-radius: 30px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: black;
		border: 1px solid white;
	}
}
</style>
